import ApiHook from './axiosAPI'

const { apiGET, apiPOST } = ApiHook()

const UsuarioAPI = {
  AtualizarUsuario: async usuario => {
    const url = `/usuarios/atualizar/`
    const req = await apiPOST(url, usuario)
    return req
  },
  BuscarUltimoPedido: async idusuario => {
    const url = `/pedidos/buscarUltimoPedidoComPartida/?id=${idusuario}`
    const req = await apiGET(url)
    return req
  },
  BuscarCartoesAtivos: async idusuario => {
    const url = `/pagamentos/buscarCartoesAtivos/`
    const req = await apiPOST(url, { idusuario })
    return req
  },
  CriarContaComprador: async dada => {
    const url = `/pagamentos/criarContaComprador/`
    const req = await apiPOST(url, dada)
    return req
  },
  RemoverCartaoCredito: async idcard => {
    const url = `/pagamentos/removerCartao/?id=${idcard}`
    const req = await apiGET(url)
    return req
  },

  BuscarAgendamentosAvulsos: async buffer => {
    const url = `/pedidos/buscarPedidosPorUsuarioComPartidasPaginado/?id=${buffer.idusuario}&limit=${buffer.limit}&offset=${buffer.offset}&status=${buffer.status}&countAll=${buffer.countAll}&typePedido=${buffer.typePedido}`
    const req = await apiGET(url)
    return req
  },
  BuscarMensalistasUsuario: async buffer => {
    const url = `/mensalista/buscarTodosPorUsuarioPaginado/?idusuario=${buffer.idusuario}&limit=${buffer.limit}&offset=${buffer.offset}&countAll=${buffer.countAll}`
    const req = await apiGET(url)
    return req
  },
  BuscarDiariasUsuario: async buffer => {
    const url = `/dayuse/buscarDayUseVendidosPorUsuario/`
    const req = await apiPOST(url, buffer)
    return req
  },
  AdicionarCartao: async buffer => {
    const url = `/pagamentos/gerarCardToken/`
    const req = await apiPOST(url, buffer)
    return req
  },
  CancelarDiaria: async buffer => {
    const url = `/dayuse/cancelarCompraDayUse/`
    const req = await apiPOST(url, buffer)
    return req
  },
  VerificarUsuarioIsGestor: async idusuario => {
    const url = `/usuarios/verificarRelacaoGestor/${idusuario}`
    const req = await apiGET(url)
    return req
  },
  ValidarContaComprador: async idusuario => {
    const url = `/pagamentos/consultarDadosUsuario/?idusuario=${idusuario}`
    const req = await apiGET(url)
    return req
  },
  ValidarTelefone: async buffer => {
    const url = `/usuarios/validate_phone/`
    const req = await apiPOST(url, buffer)
    return req
  },
  ValidarCodigoTelefone: async buffer => {
    const url = `/usuarios/validate_phone_code/`
    const req = await apiPOST(url, buffer)
    return req
  },
}

export default UsuarioAPI
